import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import {
  Box,
  Button as MUIButton,
  buttonClasses,
  ClickAwayListener,
  Grow,
  Paper,
  Popper as MUIPopper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MouseEvent, ReactNode } from 'react';
import { useRef } from 'react';

const Popper = styled(MUIPopper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
}));
const Button = styled(MUIButton)(() => ({
  padding: '9px 15px',
  lineHeight: '20px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
}));

export interface DropdownProps {
  open?: boolean;
  onOpenChange?: (v: boolean) => void;
  label: ReactNode;
  children: ReactNode;
}

export function Dropdown({
  open,
  label,
  children,
  onOpenChange,
}: DropdownProps) {
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleOpen = (_event: MouseEvent<HTMLButtonElement>) => {
    onOpenChange?.(true);
  };
  const handleClose = () => {
    onOpenChange?.(false);
  };

  return (
    <Box sx={{ flexGrow: 1, position: 'relative' }}>
      <Button
        fullWidth
        sx={{
          flex: 1,
          justifyContent: 'space-between',
          borderRadius: 2,
          pr: 1.25,
          height: 40,

          [`& .${buttonClasses.endIcon} .MuiSvgIcon-root`]: {
            fontSize: '1.5rem',
          },
        }}
        ref={anchorRef}
        color="secondary"
        variant="outlined"
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        onClick={handleOpen}
      >
        {label}
      </Button>
      {open && (
        <Popper
          open
          disablePortal
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          sx={{
            minWidth: '100%',
          }}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: 'right top',
              }}
            >
              <Paper sx={{ borderRadius: 2, overflow: 'hidden' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <div>{children}</div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </Box>
  );
}
